import { createClient, type SupabaseClient } from "@supabase/supabase-js";

let browserSupabaseClient: SupabaseClient | null = null;
let browserSupabaseAccessToken: string | null = null;

export function setSupabaseAccessToken(token: string | null): void {
  browserSupabaseAccessToken = token;
  if (browserSupabaseClient) {
    if (token) {
      void browserSupabaseClient.realtime.setAuth(token);
    }
  }
}

export function clearSupabaseAccessToken(): void {
  setSupabaseAccessToken(null);
}

export function getExistingSupabaseBrowserClient(): SupabaseClient | null {
  return browserSupabaseClient;
}

export function getSupabaseBrowserClient(): SupabaseClient {
  if (browserSupabaseClient) {
    return browserSupabaseClient;
  }

  const url = process.env.NEXT_PUBLIC_SUPABASE_URL;
  const anonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;
  if (!url || !anonKey) {
    throw new Error(
      "Missing NEXT_PUBLIC_SUPABASE_URL or NEXT_PUBLIC_SUPABASE_ANON_KEY",
    );
  }

  browserSupabaseClient = createClient(url, anonKey, {
    auth: {
      persistSession: false,
      autoRefreshToken: false,
    },
    accessToken: async () => {
      if (!browserSupabaseAccessToken) {
        throw new Error("Missing Supabase access token");
      }
      return browserSupabaseAccessToken;
    },
  });

  if (browserSupabaseAccessToken) {
    void browserSupabaseClient.realtime.setAuth(browserSupabaseAccessToken);
  }

  return browserSupabaseClient;
}
